import { Link, LinkProps } from '@mui/material';
import {
  getContentfulHref,
  getTabPropsForContentfulLink,
} from 'projects/sharedComponents/src/pet/careResources/contentful/links/contentfulLinkBuilder';

import { FC } from 'react';
import { PersonalizedVariableContentFragment } from 'projects/sharedComponents/src/generated/graphql-client-types';

type ContentfulLinkProps = { pet: PersonalizedVariableContentFragment } & LinkProps;

export const ContentfulLink: FC<ContentfulLinkProps> = ({ pet, href, children, ...props }) => {
  const tabProps = getTabPropsForContentfulLink(href ?? '');
  const url = getContentfulHref(pet, href ?? '');

  return (
    <Link {...props} href={url} {...tabProps}>
      {children}
    </Link>
  );
};
